import { SessionRecord } from "../models/session-record";

const STORAGE_KEY = "sessionHistory";
const MAX_SESSIONS = 10;

function readHistory(): SessionRecord[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeHistory(sessions: SessionRecord[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
}

export function getHistory(): SessionRecord[] {
  return readHistory();
}

export function addOrUpdateSession(session: SessionRecord) {
  const sessions = readHistory();
  const existingIndex = sessions.findIndex(
    (s) => s.magicId === session.magicId
  );

  if (existingIndex >= 0) {
    sessions[existingIndex] = { ...sessions[existingIndex], ...session };
    // Move to front
    const [updated] = sessions.splice(existingIndex, 1);
    sessions.unshift(updated);
  } else {
    sessions.unshift(session);
  }

  writeHistory(sessions.slice(0, MAX_SESSIONS));
}

export function removeSession(magicId: string) {
  const sessions = readHistory().filter((s) => s.magicId !== magicId);
  writeHistory(sessions);
}
